import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const packageApiService = createApi({
  reducerPath: "packageApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getPackage: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return `package/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    subscribe: builder.mutation({
      query: ({ id, params, body }) => {
        let query = queryParams(params);
        return {
          url: `package/subscribe/${id}${query}`,
          method: "POST",
          body,
        };
      },
    }),
    getCurrentSubscription: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `package/current${query}`,
          method: "GET",
        };
      },
    }),
    createPortalSession: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `package/create/portalsession${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    renewSubscription: builder.mutation({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `package/renew${query}`,
          method: "POST",
        };
      },
    }),
  }),
});

export const {
  useGetPackageQuery,
  useSubscribeMutation,
  useGetCurrentSubscriptionQuery,
  useCreatePortalSessionMutation,
  useRenewSubscriptionMutation,
} = packageApiService;
